module.exports = __webpack_public_path__ + "static/app-shot-1-2-f1e4deac3e245c8da0d5fea4bc1fcd5c.jpg";